import { CREATE_ORDER, CREATE_ORDER_SUCCESS, CREATE_ORDER_FAILURE, CLEAR_ORDER_CONFIRMATION, CLEAR_ORDER_ERROR, CLEAR_ORDER_LOADING } from '../types';


export const createOrder = (orderData) => ({
  type: CREATE_ORDER,
  payload: orderData
});

export const createOrderSuccess = (response) => ({
  type: CREATE_ORDER_SUCCESS,
  payload: response
});

export const createOrderFailure = (error) => ({
  type: CREATE_ORDER_FAILURE,
  error: error
});

export const clearOrderConfirmation = () => ({
  type: CLEAR_ORDER_CONFIRMATION
});

export const clearOrderError = () => ({
  type: CLEAR_ORDER_ERROR
});

export const clearOrderLoading = () => ({
  type: CLEAR_ORDER_LOADING
});
